import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, CheckIcon } from 'lucide-react';
export type AccordionItemData = {
  title: string;
  items: string[];
  image?: string;
  badge?: string;
};
type AccordionProps = {
  data: AccordionItemData[];
  defaultOpen?: number | null;
};
export function Accordion({
  data,
  defaultOpen = 0
}: AccordionProps) {
  const [open, setOpen] = useState<number | null>(defaultOpen);
  return <ul className="space-y-2.5" data-id="element-16" data-mp="2n5saj18cq20d">
      {data.map((entry, i) => {
      const isOpen = open === i;
      return <li key={entry.title} className="overflow-hidden rounded-2xl border border-[#c9d6cd] bg-white/85 backdrop-blur-sm" data-id="element-17" data-mp="2w4dmuen8cksp" data-mpi={i}>
            <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center gap-3 px-4 py-3.5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#6f8f7c]" data-id="element-18" data-mp="2s0xsjoymuwj6">
              <span className="flex-1 text-[14px] font-bold leading-snug text-[#16302a]" data-id="element-19" data-mp="3g20z9ldp9pfm">
                {entry.title}
                {entry.badge ? <span className="ml-2 rounded-full bg-[#e5efe7] px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-[#3f5d4e]" data-id="element-20" data-mp="3q18lky2ewuev">
                    {entry.badge}
                  </span> : null}
              </span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 text-[#6f8f7c] transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-21" data-mp="3p1m15nwf9h8" />
            </button>

            <AnimatePresence initial={false} data-id="element-22" data-mp="hn00eb27z5wq">
              {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.28,
            ease: [0.22, 1, 0.36, 1]
          }} className="overflow-hidden" data-id="element-23" data-mp="2eeqdnlnm3v0g">
                  <div className="border-t border-[#e2ebe4] px-4 pb-4 pt-3" data-id="element-24" data-mp="27cbt6edivolj">
                    {entry.image ? <a href="#compra" aria-label="Ir a la sección de compra" data-id="element-25" data-mp="2lc4f7we3tgn6">
                        <img src={entry.image} alt={entry.title.replace(/^[^A-Za-z]+/, '')} className="mb-3 w-full rounded-xl border border-[#e2ebe4] object-cover" data-id="element-26" data-mp="2gbyt0vqlsmch" />
                      </a> : null}
                    <ul className="space-y-2" data-id="element-27" data-mp="340hsqmvl7qsy">
                      {entry.items.map(item => <li key={item} className="flex gap-2.5" data-id="element-28" data-mp="2z4165x41dkhz">
                          <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#6f8f7c]" aria-hidden="true" data-id="element-29" data-mp="3dzh2y9w03ui2" />
                          <span className="text-[13.5px] leading-relaxed text-[#3d4f47]" data-id="element-30" data-mp="391ozqjpwolyk">{item}</span>
                        </li>)}
                    </ul>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </li>;
    })}
    </ul>;
}